import React from 'react';
import Card, { CardSeparator } from '../components/Card';
import CardHeader from '../components/CardHeader';
import DeltaPreview from '../components/DeltaPreview';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import PostBadge from '../post/PostBadge';
import PostTitleWithIcons from '../post/PostTitleWithIcons';
import extractContent from '../post/extractContent';
import PostSeriesMeta from '../post/series/PostSeriesMeta';
import postPath from '../utils/url/postPath';
import * as styles from './ActivityPostCard.module.scss';

const POST_FRAGMENT = gql(`
  fragment ActivityPostCard_post on Post {
    id
    content {
      id
      delta
    }
    ...postPath_post
    ...PostBadge_post
    series {
      id
    ...PostSeriesMeta_series
    }
    ...PostTitleWithIcons_post
  }
`);

interface ActivityPostCardProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  maxLines?: number;
}

const ActivityPostCard = ({ post, maxLines }: ActivityPostCardProps) => (
  <Card to={postPath(post)}>
    <CardHeader
      aboveTitle={
        post.series && (
          <div className={styles.seriesContainer}>
            <PostSeriesMeta postId={post.id} series={post.series} />
          </div>
        )
      }
      title={<PostTitleWithIcons post={post} />}
    />
    <CardSeparator />
    <DeltaPreview
      typography="activity"
      content={extractContent(post.content.delta)}
      maxLines={maxLines}
    />
    <div className={styles.footer}>
      <PostBadge post={post} inline={false} />
    </div>
  </Card>
);

export default ActivityPostCard;
